module.exports = __webpack_public_path__ + "img/_video_normalize.5ad96e9d.svg";